import {
  UserType,
  BookingServiceCode as SrvCodes,
} from '@ngb-frontend/shared/types'
import { countryCodeToOrg, systemCodeToOrg } from '@ngb-frontend/shared/utils'

import type { SystemCode, QueryCountryCode } from '@ngb-frontend/shared/types'

export const isValidSystemCountry = (
  systemCode: SystemCode,
  countryCode: QueryCountryCode,
) => {
  const organization = countryCodeToOrg[countryCode]

  // Ensure it is supported
  return !!(organization &&
  organization === systemCodeToOrg[systemCode as SystemCode]
    ? countryCode
    : null)
}

export const isValidSystemService = (user: UserType, srv: string) => {
  const serviceCodes = Object.values(SrvCodes)

  if (!serviceCodes.includes(srv as SrvCodes) || user === UserType.Unknown) {
    return false
  }

  if (
    (user === UserType.Driver && srv !== SrvCodes.MnR) ||
    (user === UserType.Broker && srv !== SrvCodes.EoL)
  ) {
    return false
  }

  return true
}
